import { Box, adaptV4Theme } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { createTheme, ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { Pagination } from '@mui/material';

import React from 'react';

const MyPagination = ({ count, onChange, color, ...props }) => {
  const isRTL = props.i18n.translator.language;

  const themeRtl = createTheme(adaptV4Theme({
    direction: isRTL === 'ar' ? "rtl" : "ltr"
  }));

  return (<>
    {count >= 2 && (
      <Box py={4} display="flex" alignItems="center" justifyContent="center">
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={themeRtl}>
            <Pagination
              count={count}
              color="primary"
              style={{ color: 'white' }}
              onChange={(_, val) => onChange(val)}
              {...props}
            />
          </ThemeProvider>
        </StyledEngineProvider>
      </Box>
    )}
  </>);
};

export default withTranslation('common')(MyPagination);
